import { authenType } from '../action/types';
import { createSlice, createAction } from "@reduxjs/toolkit";
import { handleFail } from "../redux-util";

const initialState = {
    menuGroupType : [],
    menuType : [],
    newsType : [],
    templateType : [],
    userRole : [],
    userStatus : [],
}

const slice = createSlice({
    initialState,
    name: "master",
    reducers: {
      getConstants: () => { },
      getConstantsSuccess: (state, { payload = {} }) => {
        return { ...state, ...payload };
      },
      getConstantsFailure: handleFail,
      //////////////////////////////////////////////////
    },
  });

  export const {
    getConstants,
    getConstantsSuccess,
    getConstantsFailure,
  
} = slice.actions;

export default slice.reducer;